<template>
    <reo-dialog
        @cancel="$emit('cancel')"
        title="Sign Paypal"
    >
        <!-- Paypal Sign-->
        <div class="paypal-container">
            <ReoProcessing class='processing' v-show="loading"/>
            <div id="smart-button-payment" v-show="!loading"></div>
            <div class='error' v-if="error">{{ error }}</div>
        </div>
    </reo-dialog>
</template>
<script lang="ts">
import Vue from 'vue';
import ReoDialog from '@/basic/Dialog.vue';
import ReoProcessing from '@/basic/processing.vue';
import { payManager } from '@/lib/payManager';
export default Vue.extend({
    name: 'SignPaypalDialog',
    components: {
        ReoDialog,
        ReoProcessing
    },
    props: {
        serviceId: String
    },
    data() {

        return {
            loading: true,
            error: ''
        };

    },
    async mounted() {

        await this.signPaypal();

    },
    methods: {
        async signPaypal(): Promise<void> {

            try {

                await payManager.initPaypal2Sign(
                    this.serviceId,
                    '#smart-button-payment',
                    () => this.$emit( 'success' )
                );
                this.loading = false;

            } catch ( error ) {

                this.error = 'error';
                this.$emit( 'cancel' );
                console.error( error );

            } finally {

                this.loading = false;

            }

        }
    }
});
</script>

<style lang="less" scoped>
.paypal-container{
    min-height: 60px;
    min-width: 324px;
    .processing{
        & /deep/ .blinking{
            background-color: @bg_02;
        }
    }

    @media @mobile {
        min-width: unset;
    }
}
</style>
